// bankDimensions.js
// Breakpoint: mobile = window.innerWidth <= 768

import { useEffect, useState } from "react";

export const bankDimensions = {
  1: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Agrario de Colombia
  2: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco AV Villas
  3: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco BBVA
  4: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Caja Social
  5: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Citibank
  6: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Davivienda
  7: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco de Bogotá
  8: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco de Occidente
  9: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Falabella
  10: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Finandina
  11: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco GNB Sudameris
  12: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Itaú Corpbanca
  13: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Mundo Mujer
  14: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Pichincha
  15: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Popular
  16: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Credifinanciera
  17: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Santander
  18: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Bancamia S.A
  19: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco Serfinanza
  20: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Bancoldex
  21: {
    desktop: { width: "13rem", height: "10rem" },
    mobile: { width: "12rem", height: "9rem" },
  }, // Bancolombia  ← logo grande vertical
  22: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Bancoomeva
  23: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // BNP Paribas
  24: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Coltefinanciera
  25: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Financiera Juriscoop
  26: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Banco JP Morgan
  27: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Mibanco S.A
  28: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Red Multibanca Colpatria
  29: {
    desktop: { width: "10rem", height: "4rem" },
    mobile: { width: "7rem", height: "3rem" },
  }, // Simple S.A ← sin logo, retorna null
  30: {
    desktop: { width: "8rem", height: "8rem" },
    mobile: { width: "6rem", height: "6rem" },
  }, // Nequi        ← logo cuadrado
  31: {
    desktop: { width: "16rem", height: "13rem" },
    mobile: { width: "12rem", height: "10rem" },
  }, // Daviplata    ← logo grande vertical
  32: {
    desktop: { width: "8rem", height: "8rem" },
    mobile: { width: "6rem", height: "6rem" },
  }, // Nu Bank      ← logo cuadrado/redondo
  33: {
    desktop: { width: "8rem", height: "8rem" },
    mobile: { width: "6rem", height: "6rem" },
  }, // Lulo Bank    ← logo cuadrado
};

export const DEFAULT_BANK_DIMENSIONS = {
  desktop: { width: "10rem", height: "4rem" },
  mobile: { width: "7rem", height: "3rem" },
};


export const useWindowSize = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handler = () =>
      setSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return size;
};